import React from 'react';

const iosSettingsDef = [
  {
    key: 'safari_status_bar',
    label: 'Status Bar Style',
    type: 'select',
    options: [
      { value: 'default', label: 'Default' },
      { value: 'black', label: 'Black' },
      { value: 'black-translucent', label: 'Black Translucent' }
    ],
    description: 'Controls the iOS status bar appearance when running as PWA'
  },
  {
    key: 'apple_touch_icon',
    label: 'Apple Touch Icon',
    type: 'toggle',
    description: 'Use custom icon for iOS home screen'
  },
  {
    key: 'splash_screen',
    label: 'Splash Screen',
    type: 'toggle',
    description: 'Show launch splash screen on iOS'
  },
  {
    key: 'fullscreen',
    label: 'Full Screen Mode',
    type: 'toggle',
    description: 'Hide Safari UI when launched from home screen'
  }
];

const androidSettingsDef = [
  {
    key: 'install_banner',
    label: 'Install Banner',
    type: 'toggle',
    description: 'Show Chrome install banner when criteria are met'
  },
  {
    key: 'chrome_theme_color',
    label: 'Chrome Theme Color',
    type: 'color',
    description: 'Color of the Chrome browser toolbar'
  },
  {
    key: 'display_mode',
    label: 'Display Mode',
    type: 'select',
    options: [
      { value: 'standalone', label: 'Standalone' },
      { value: 'fullscreen', label: 'Fullscreen' },
      { value: 'minimal-ui', label: 'Minimal UI' },
      { value: 'browser', label: 'Browser' }
    ],
    description: 'How the app is displayed when launched'
  },
  {
    key: 'orientation',
    label: 'Orientation',
    type: 'select',
    options: [
      { value: 'portrait', label: 'Portrait' },
      { value: 'landscape', label: 'Landscape' },
      { value: 'any', label: 'Any' }
    ],
    description: 'Preferred screen orientation'
  }
];

const PlatformSettingsPanel = ({ platform, settings, onChange }) => {
  const defs = platform === 'ios' ? iosSettingsDef : androidSettingsDef;

  return (
    <div className="space-y-4">
      {defs?.map((def) => (
        <div key={def?.key} className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground">{def?.label}</p>
            <p className="text-xs text-muted-foreground">{def?.description}</p>
          </div>
          <div className="flex-shrink-0">
            {def?.type === 'toggle' && (
              <button
                type="button"
                onClick={() => onChange(def?.key, !settings?.[def?.key])}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                  settings?.[def?.key] ? 'bg-primary' : 'bg-muted-foreground/30'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    settings?.[def?.key] ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            )}
            {def?.type === 'select' && (
              <select
                value={settings?.[def?.key] || ''}
                onChange={(e) => onChange(def?.key, e?.target?.value)}
                className="px-3 py-1.5 border border-border rounded-lg bg-background text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary/30"
              >
                {def?.options?.map((opt) => (
                  <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
                ))}
              </select>
            )}
            {def?.type === 'color' && (
              <div className="flex items-center gap-2">
                <input
                  type="color"
                  value={settings?.[def?.key] || '#1e3a5f'}
                  onChange={(e) => onChange(def?.key, e?.target?.value)}
                  className="w-9 h-9 rounded-lg border border-border cursor-pointer"
                />
                <input
                  type="text"
                  value={settings?.[def?.key] || ''}
                  onChange={(e) => onChange(def?.key, e?.target?.value)}
                  className="w-24 px-2 py-1.5 border border-border rounded-lg bg-background text-foreground text-xs focus:outline-none focus:ring-2 focus:ring-primary/30"
                  placeholder="#1e3a5f"
                />
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlatformSettingsPanel;
